import VideoEmbedded from "@pathwright/ui/src/components/video/VideoEmbedded"
import classnames from "classnames"
import Text from "lib/core/components/text/Text"
import "./Video.css"

const VideoContent = function ({ step, content }) {
  const {
    method,
    embed_code,
    video_embed_code,
    content_embed_code,
    listed_instructions
  } = content

  const className = classnames(
    "Content__Video",
    { "Content--padded": method === "listed" },
    `Content__Video--${method}`
  )

  // PW2 prefers shared content_embed_code now.
  const embed = content_embed_code || video_embed_code || embed_code

  return (
    <div className={className}>
      {(() => {
        switch (method) {
          case "embed":
            return <VideoEmbedded embed={embed} fitvid={true} />
          case "listed":
            return <Text html={listed_instructions} katex={true} theme={true} />
          // when "wistia"
          //   <WistaPlayer id={content.wistia_id} />
        }
      })()}
    </div>
  )
}

VideoContent.displayName = "Video"

export default VideoContent
